import { CMS_URL } from "@/constants";

export const generateCMSImageUrl = (imageUrl: string): string =>
  `${CMS_URL}${imageUrl}`;
